import { PalletsResponseModel, RackPostionReq } from '@gtpl/shared-models/masters';
import { AssigningStockResponse, CommonResponse, GetAllRepackingStockResponseModel, GetAllStockResponseModel, getDispatchListResponseModel, GetForkLiftJobResponseModel, GetStockResponseModel, PlantIdRequest, RackPositionServiceResponseModel, RackSuggestionsResponseModel, RepackingDtoRequest, StockAssigningResponse, StockOutResponse, StockQtyResponseModel, StockResponseData, ReprocessingInputRequest, SaleOrderIdRequest, getAllStockInDetailsResponseModel, WarehouseResponseModel, StockTransferModel, WarehouseDashboardResponseModel, FgStockReportResponse, FgStockReportModel, StockOutTransactionRequest, SoIdRequest, AssignRepackingRequest, AssignSuperDummyRepackingRequest, StockInReverseReq, AllocationRevereseRequest, LocationUpdateRequest, StockUpdateByDomestic, StockIdsReq, StockOutTypeReq } from '@gtpl/shared-models/warehouse-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { ReportedStockRequest } from '../stock-in/dto/reported-stock.request';
import { FGReStockData } from './dto/all-re-packorprocess-stock.dto';
import { RackPositionRequest } from './dto/rack-postion.request';
import { InputIdRequest } from './dto/input-id.request';
import { palletLocationRequest } from './dto/pallet-location-dto'
import { StockSoItemRequest } from './dto/stock-so-item.request';
import { StockSoRequest } from './dto/stock-so.request';
import { StockStatusRequest } from './dto/stock-status.request';
import { StockDto } from './dto/stock.dto';
import { StockService } from './stock.service';
import { saleOrderItemIdRequest, SaleOrderItemsBySoIdReaponseModel } from '@gtpl/shared-models/sale-management';
import { RackPositionQtyRequest } from './dto/rack-position-qty.request';
import { OutBoundRequest } from './dto/out-bound.request';
import { SoPlantRequest } from './dto/so-plant.request';
import { WarehouseView } from './warehouse-view.entity';
import { PlantZone } from './dto/plant-zone.request.dto';
import appSettings from 'apps/services/config';
import { LotCodesRequest } from './dto/lot-codes.request';
import { LotCodesResponseModel } from '@gtpl/shared-models/raw-material-procurement';
import { RackReserveRequest } from './dto/rack-reserve.request';
import { RackZoneLevelRequest } from './dto/zone-rack-level.request';
import { StockTransferDto } from './dto/stock-transfer.dto';
import { BulkStockOutRequest } from './dto/bulk-stock-out.request';
import { SaleOrderRequest } from '@gtpl/shared-models/logistics';
import { SaleOrderItemsRequest } from './dto/sale-order-items-request';
import { ReProcessingDtoReq } from './dto/reprocess-request';
import { StockInTransactionsRequest, StockReportFilters, UnitRequest } from '@gtpl/shared-models/common-models';
import { FgSaleReportRequest } from './repositories/fg-sale-report.request';
import { ShipmentStatusRequest } from './dto/shipment-status.report';
import { DPReportRequest } from './dto/dummy-packing-report.request';

@ApiTags('Stock')
@Controller('stock')
export class StockController {
  constructor(
    private stockService: StockService,
    private readonly applicationExceptionhandler: ApplicationExceptionHandler,

  ) { }

  @Post('/getStockBySoItemId')
  async getStockBySoItemId(@Body() stockSoItemRequest: StockSoItemRequest): Promise<GetStockResponseModel> {
    try {
      return await this.stockService.getStockBySoItemId(stockSoItemRequest);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(GetStockResponseModel, error);
    }
  }
  @Post('/getStockBySoId')
  async getStockBySoId(@Body() stockSoRequest: StockSoRequest): Promise<GetAllStockResponseModel> {
    try {
      console.log(stockSoRequest);
      return await this.stockService.getStockBySoId(stockSoRequest);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(GetAllStockResponseModel, error);
    }
  }
  @Post('/getDispatchlistForSo')
  async getDispatchlistForSo(@Body() stockSoRequest: StockSoRequest): Promise<GetAllStockResponseModel> {
    try {
      console.log(stockSoRequest);
      return await this.stockService.getDispatchlistForSo(stockSoRequest);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(GetAllStockResponseModel, error);
    }
  }
  @Post('/createStock')
  async createStock(@Body() stockDto: StockDto, isUpdate: boolean = false): Promise<GetStockResponseModel> {
    try {
      return await this.stockService.createStock(stockDto, false);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(GetStockResponseModel, error)
    }
  }

  @Post('/createReportedStock')
  async createReportedStock(@Body() stockDto: StockDto, isUpdate: boolean = false): Promise<GetStockResponseModel> {
    try {
      return await this.stockService.createReportedStock(stockDto, false);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(GetStockResponseModel, error)
    }
  }
  @Post('/updateStock')
  async updateStock(@Body() stockDto: StockDto): Promise<GetStockResponseModel> {
    try {
      return await this.stockService.createStock(stockDto, true);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(GetStockResponseModel, error)
    }
  }
  @Post('/getAllStockData')
  async getAllStockData(): Promise<GetAllStockResponseModel> {
    try {
      return await this.stockService.getAllStockData();
    } catch (error) {
      return this.applicationExceptionhandler.returnException(GetAllStockResponseModel, error);
    }
  }
  @Post('/getAllStock')
  async getAllStock(@Body() plantIdRequest: PlantIdRequest): Promise<StockResponseData> {
    try {
      return await this.stockService.getAllStock(plantIdRequest.plantId, 0, plantIdRequest.role,plantIdRequest.varientId);
    } catch (error) {
      return error;
      // return this.applicationExceptionhandler.returnException(GetAllStockResponseModel, error);
    }
  }
  @Post('/updateStockStatus')
  async updateStockStatus(@Body() stockStatusRequest: StockStatusRequest): Promise<boolean> {
    try {
      return await this.stockService.updateStockStatus(stockStatusRequest);
    } catch (error) {
      return error
    }
  }

  @Post('/getReProcessingStock')
  async getReProcessingStock(@Body() req: ReProcessingDtoReq): Promise<AssigningStockResponse> {
    try {
      return await this.stockService.getReProcessingStock(req);
    } catch (error) {
      return error
    }
  }
  @Post('/getLotWiseReportedQuantity')
  async getLotWiseReportedQuantity(): Promise<any> {
    try {
      return await this.stockService.getLotWiseReportedQuantity();
    } catch (error) {
      return error
    }
  }

  @Post('/getRePackingStock')
  async getRePackingStock(@Body() req: RepackingDtoRequest): Promise<AssigningStockResponse> {
    try {
      return await this.stockService.getRePackingStock(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(AssigningStockResponse, error);
    }
  }

  @Post('/getAllAssignableReProcessingStock')
  async getAllAssignableReProcessingStock(@Body() req: ReProcessingDtoReq): Promise<GetAllRepackingStockResponseModel> {
    try {
      return await this.stockService.getAllAssignableReProcessingStock(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(GetAllRepackingStockResponseModel, error);
    }
  }

  @Post('/getAllAssignableRePackingStock')
  async getAllAssignableRePackingStock(@Body() req: RepackingDtoRequest): Promise<GetAllRepackingStockResponseModel> {
    try {
      return await this.stockService.getAllAssignableRePackingStock(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(GetAllRepackingStockResponseModel, error);
    }
  }

  @Post('/AssignQty')
  async AssignQty(@Body() req: FGReStockData): Promise<StockAssigningResponse> {
    try {
      return await this.stockService.AssignQty(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(StockAssigningResponse, error);
    }
  }

  @Post('/AssignReprocessQty')
  async AssignReprocessQty(@Body() req: ReprocessingInputRequest): Promise<StockAssigningResponse> {
    try {
      return await this.stockService.AssignReprocessQty(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(StockAssigningResponse, error);
    }
  }

  @Post('/getRackSuggestion')
  async getRackSuggestion(@Body() req: RackPositionRequest): Promise<RackSuggestionsResponseModel> {
    try {
      return await this.stockService.getRackSuggestion(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(RackSuggestionsResponseModel, error);
    }
  }

  /**
   * get product details for a pallet relared sale order item id
   * @param req 
   * @returns 
   */

  @Post('/productDetailsForPalletId')
  async productDetailsForPalletId(@Body() req: InputIdRequest): Promise<SaleOrderItemsBySoIdReaponseModel> {
    try {
      return await this.stockService.productDetailsForPalletId(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(SaleOrderItemsBySoIdReaponseModel, error);
    }
  }

  /**
   * get pallet details for rack position id
   * @param req 
   * @returns 
   */
  @Post('/getPalletDetailsForRackPosition')
  async getPalletDetailsForRackPosition(@Body() req: InputIdRequest): Promise<PalletsResponseModel> {
    try {
      return await this.stockService.getPalletDetailsForRackPosition(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(PalletsResponseModel, error);
    }
  }
  @Post('/getRackPostionToAssign')
  async getRackPostionToAssign(@Body() req: RackPositionQtyRequest): Promise<RackPositionServiceResponseModel> {
    try {
      return await this.stockService.getRackPostionToAssign(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(RackPositionServiceResponseModel, error);
    }
  }

  @Post('/getOutBoundDataSubmission')
  async getOutBoundDataSubmission(@Body() req: OutBoundRequest): Promise<GetForkLiftJobResponseModel> {
    try {
      return await this.stockService.getOutBoundDataSubmission(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(GetForkLiftJobResponseModel, error);
    }
  }

  @Post('/getStockQtyForSo')
  async getStockQtyForSo(@Body() req: StockSoRequest): Promise<StockQtyResponseModel> {
    try {

      return await this.stockService.getStockQtyForSo(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(StockQtyResponseModel, error);
    }
  }
  @Post('/getStockQtyForSoAndSoItem')
  async getStockQtyForSoAndSoItem(@Body() req: SaleOrderItemsRequest): Promise<StockQtyResponseModel> {
    try {

      return await this.stockService.getStockQtyForSoAndSoItem(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(StockQtyResponseModel, error);
    }
  }


  /**
   * get stock in data with stock in status
   * @param req 
   * @returns 
   */

  @Post('/getStockInData')
  async getStockInData(@Body() req: SoPlantRequest): Promise<StockOutResponse> {
    try {
      return await this.stockService.getStockInData(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(StockOutResponse, error);
    }
  }

  @Post('/updateStockOutStatus')
  async updateStockOutStatus(@Body() stockStatusRequest: BulkStockOutRequest[]): Promise<CommonResponse> {
    try {
      return await this.stockService.updateStockOutStatus(stockStatusRequest);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getStockOutData')
  async getStockOutData(@Body() req: PlantIdRequest): Promise<getDispatchListResponseModel> {
    try {
      return await this.stockService.getStockOutData(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(getDispatchListResponseModel, error);
    }
  }

  @Post('/getStockInSaleOrders')
  async getStockInSaleOrders(@Body() req: InputIdRequest): Promise<CommonResponse> {
    try {
      return await this.stockService.getStockInSaleOrders(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getStockInSaleOrdersDropdown')
  async getStockInSaleOrdersDropdown(): Promise<CommonResponse> {
    try {
      return await this.stockService.getStockInSaleOrdersDropdown();
    } catch (error) {
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }
  @Post('updatePalletLocation')
  async updatePalletLocation(@Body() req: palletLocationRequest): Promise<boolean> {
    try {
      return await this.stockService.updatePalletLocation(req);
    } catch (error) {
      return true;
    }

  }
  @Post('/getReportedStockForSoId')
  async getReportedStockForSoId(@Body() req: SoPlantRequest): Promise<StockResponseData> {
    try {
      //  console.log(req);
      return await this.stockService.getReportedStockForSoId(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(StockResponseData, error);
    }
  }
  @Post('/getWarehouseView')
  async getWarehouseView(@Body() req: PlantZone): Promise<StockResponseData> {
    try {
      return await this.stockService.getWarehouseView(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(StockResponseData, error);
    }
  }
  @Post('/getRackDetails')
  async getRackDetails(@Body() req: RackReserveRequest): Promise<StockResponseData> {
    try {
      return await this.stockService.getRackDetails(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(StockResponseData, error);
    }
  }


  @Post('/getLotCodesBySoIdAndSoItemIdTemporary')
  async getLotCodesBySoIdAndSoItemIdTemporary(@Body() req: LotCodesRequest): Promise<LotCodesResponseModel> {
    try {
      return await this.stockService.getLotCodesBySoIdAndSoItemIdTemporary(req);
    } catch (err) {
      return this.applicationExceptionhandler.returnException(LotCodesResponseModel, err);
    }
  }
  @Post('/getStockForPlant')
  async getStockForPlant(@Body() req: PlantIdRequest): Promise<CommonResponse> {
    try {
      return await this.stockService.getStockForPlant(req);
    } catch (err) {
      return this.applicationExceptionhandler.returnException(LotCodesResponseModel, err);
    }
  }

  @Post('/getStockSummaryReportData')
  async getStockSummaryReportData(@Body() req: RackZoneLevelRequest): Promise<CommonResponse> {
    try {
      return await this.stockService.getStockSummaryReportData(req);
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }



  @Post('/getTransferStock')
  async getTransferStock(@Body() req: StockTransferDto): Promise<CommonResponse> {
    try {
      return await this.stockService.getTransferStock(req);
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }

  @Post('/getAllStockForStockReport')
  async getAllStockForStockReport(@Body() req?: StockReportFilters): Promise<StockResponseData> {
    try {
      return await this.stockService.getAllStockForStockReport(req);
    } catch (error) {
      return error;
      // return this.applicationExceptionhandler.returnException(GetAllStockResponseModel, error);
    }
  }
  @Post('getColdDropForStockRep')
  async getColdDropForStockRep(@Body() req: UnitRequest): Promise<CommonResponse> {
    try {
      return await this.stockService.getColdDropForStockRep(req);
    } catch (error) {
      return error;
    }
  }

  @Post('/getMoveStockToDummy')
  async getMoveStockToDummy(@Body() req: SoPlantRequest): Promise<CommonResponse> {
    try {
      return await this.stockService.getMoveStockToDummy(req);
    } catch (error) {
      // return error;
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getWarehouseRackDetails')
  async getWarehouseRackDetails(@Body() req: RackReserveRequest): Promise<WarehouseDashboardResponseModel> {
    try {
      return await this.stockService.getWarehouseRackDetails(req);
    } catch (error) {
      // return error;
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }
  
  @Post('/getAllFgStockReport')
  async getAllFgStockReport(@Body() req: FgSaleReportRequest): Promise<FgStockReportResponse> {
    try {
      return await this.stockService.getAllFgStockReport(req);
    }
    catch (error) {
      return this.applicationExceptionhandler.returnException(FgStockReportResponse, error);
    }
  }
  @Post('/getProductDropForFgStockReport')
  async getProductDropForFgStockReport(@Body() req: UnitRequest): Promise<FgStockReportResponse> {
    try {
      return await this.stockService.getProductDropForFgStockReport(req);
    }
    catch (error) {
      return this.applicationExceptionhandler.returnException(FgStockReportResponse, error);
    }
  }
  @Post('/getStockOutTransaction')
  async getStockOutTransaction(@Body() req?: StockOutTransactionRequest): Promise<CommonResponse> {
    try {
      return await this.stockService.getStockOutTransaction(req);
    }
    catch (error) {
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getStockInTransactions')
  async getStockInTransactions(@Body() req?: StockInTransactionsRequest): Promise<CommonResponse> {
    try {
      return await this.stockService.getStockInTransactions(req);
    }
    catch (error) {
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getStockInReverseTransactions')
  async getStockInReverseTransactions(@Body() req?: PlantIdRequest): Promise<CommonResponse> {
    try {
      return await this.stockService.getStockInReverseTransactions(req);
    }
    catch (error) {
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getAllStockOutSaleOrders')
  async getAllStockOutSaleOrders(@Body() req?: UnitRequest): Promise<CommonResponse> {
    try {
      return await this.stockService.getAllStockOutSaleOrders(req);
    }
    catch (error) {
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getStockInUsage')
  async getStockInUsage(): Promise<any> {
    try {
      return await this.stockService.getStockInUsage();
    } catch (error) {
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getStockOutUsage')
  async getStockOutUsage(): Promise<any> {
    try {
      return await this.stockService.getStockOutUsage();
    } catch (error) {
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }
  @Post('getShiftsDropdownForStockInReport')
  async getShiftsDropdownForStockInReport(req?: UnitRequest): Promise<CommonResponse> {
    console.log(req, 'req')
    try {
      return await this.stockService.getShiftsDropdownForStockInReport(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }
  @Post('getUnitDropdownForStockInReport')
  async getUnitDropdownForStockInReport(): Promise<CommonResponse> {
    try {
      return await this.stockService.getUnitDropdownForStockInReport();
    } catch (error) {
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }
  @Post('getPoNoForFgStockReport')
  async getPoNoForFgStockReport(@Body() req:UnitRequest): Promise<CommonResponse> {
    try {
      return await this.stockService.getPoNoForFgStockReport(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }
  @Post('getBrandDropForFgStockReport')
  async getBrandDropForFgStockReport(@Body() req:UnitRequest): Promise<CommonResponse> {
    try {
      return await this.stockService.getBrandDropForFgStockReport(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }
  @Post('getCategoryDropForFgStockReport')
  async getCategoryDropForFgStockReport(@Body() req:UnitRequest): Promise<CommonResponse> {
    try {
      return await this.stockService.getCategoryDropForFgStockReport(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }
  @Post('getUnitDropdownForStockReport')
  async getUnitDropdownForStockReport(): Promise<CommonResponse> {
    try {
      return await this.stockService.getUnitDropdownForStockReport();
    } catch (error) {
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }

  @Post('/moveLeftOverQtytoDummy')
  async moveLeftOverQtytoDummy(@Body() req: SoIdRequest): Promise<CommonResponse> {
    try {
      console.log(req);
      return await this.stockService.moveLeftOverQtytoDummy(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getShipmentStatusReport')
  async getShipmentStatusReport(@Body() req?: ShipmentStatusRequest): Promise<CommonResponse> {
    try {
      return await this.stockService.getShipmentStatusReport(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getSoDropForShipmentStatusReport')
  async getSoDropForShipmentStatusReport(@Body() req: UnitRequest): Promise<CommonResponse> {
    try {
      return await this.stockService.getSoDropForShipmentStatusReport(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getbrandDropForShipmentStatusReport')
  async getbrandDropForShipmentStatusReport(@Body() req: UnitRequest): Promise<CommonResponse> {
    try {
      return await this.stockService.getbrandDropForShipmentStatusReport(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getStockDetails')
  async getStockDetails(@Body() req?: RackPostionReq): Promise<CommonResponse> {
    try {
      return await this.stockService.getStockDetails(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getDummyPackingReport')
  async getDummyPackingReport(@Body() req?: DPReportRequest): Promise<CommonResponse> {
    try {
      return await this.stockService.getDummyPackingReport(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getBrandDropForDummyPackingReport')
  async getBrandDropForDummyPackingReport(@Body() req: UnitRequest): Promise<CommonResponse> {
    try {
      return await this.stockService.getBrandDropForDummyPackingReport(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getVariantDropForDummyPackingReport')
  async getVariantDropForDummyPackingReport(@Body() req: UnitRequest): Promise<CommonResponse> {
    try {
      return await this.stockService.getVariantDropForDummyPackingReport(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getVariantDropdown')
  async getVariantDropdown(@Body() req?: RackZoneLevelRequest): Promise<CommonResponse> {
    try {
      return await this.stockService.getVariantDropdown(req);
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }

  @Post('/getValueAdditionsFiltersData')
  async getValueAdditionsFiltersData(): Promise<CommonResponse> {
    try {
      return await this.stockService.getValueAdditionsFiltersData();
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }

  @Post('/getValueAdditionsTwoFiltersData')
  async getValueAdditionsTwoFiltersData(): Promise<CommonResponse> {
    try {
      return await this.stockService.getValueAdditionsTwoFiltersData();
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }

  @Post('/getValueAdditionsThreeFiltersData')
  async getValueAdditionsThreeFiltersData(): Promise<CommonResponse> {
    try {
      return await this.stockService.getValueAdditionsThreeFiltersData();
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }

  @Post('/getValueAdditionsfourFiltersData')
  async getValueAdditionsfourFiltersData(): Promise<CommonResponse> {
    try {
      return await this.stockService.getValueAdditionsfourFiltersData();
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }

  @Post('/getValueAdditionsfiveFiltersData')
  async getValueAdditionsfiveFiltersData(): Promise<CommonResponse> {
    try {
      return await this.stockService.getValueAdditionsfiveFiltersData();
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }
  

  @Post('/updateWHAnalyticsDB')
  async updateWHAnalyticsDB(): Promise<CommonResponse> {
    try {
      return await this.stockService.updateWHAnalyticsDB();
    } catch (error) {
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getFoodTypeFiltersData')
  async getFoodTypeFiltersData(): Promise<CommonResponse> {
    try {
      return await this.stockService.getFoodTypeFiltersData();
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }
  @Post('/getLifeCycleUsage')
  async getLifeCycleUsage(): Promise<CommonResponse> {
    try {
      return await this.stockService.getLifeCycleUsage();
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }
  @Post('/dummyAndFgStockWtsApp')
  async dummyAndFgStockWtsApp(): Promise<CommonResponse> {
    try {
      return await this.stockService.dummyAndFgStockWtsApp();
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }
  @Post('/getDeadStockData')
  async getDeadStockData(@Body() req?: StockReportFilters): Promise<CommonResponse> {
    try {
      return await this.stockService.getDeadStockData(req);
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }
  @Post('/getDummyProducts')
  async getDummyProducts(): Promise<CommonResponse> {
    try {
      return await this.stockService.getDummyProducts();
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }
  @Post('/getDummyStock')
  async getDummyStock(@Body() req:PlantIdRequest): Promise<CommonResponse> {
    try {
      return await this.stockService.getDummyStock(req);
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }
  @Post('/getSaleOrderToAssignRepacking')
  async getSaleOrderToAssignRepacking(@Body() req:AssignRepackingRequest): Promise<CommonResponse> {
    try {
      return await this.stockService.getSaleOrderToAssignRepacking(req);
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }
  @Post('/generatePickList')
  async generatePickList(@Body() req:SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      return await this.stockService.generatePickList(req);
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }
  @Post('/getCheckPickListGeneratedORNot')
  async getCheckPickListGeneratedORNot(@Body() req:SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      return await this.stockService.getCheckPickListGeneratedORNot(req);
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }
  @Post('/getPOsInStock')
  async getPOsInStock(@Body() req:SaleOrderIdRequest): Promise<CommonResponse> {
    try {
      return await this.stockService.getPOsInStock(req);
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }
  @Post('/getSaleOrderToAssignReprocessing')
  async getSaleOrderToAssignReprocessing(@Body() req:AssignRepackingRequest): Promise<CommonResponse> {
    try {
      return await this.stockService.getSaleOrderToAssignReprocessing(req);
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }
  @Post('/getProductDropForStockReport')
  async getProductDropForStockReport(@Body() req: UnitRequest): Promise<CommonResponse> {
    try {
      return await this.stockService.getProductDropForStockReport(req);
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }
  @Post('/getProductDropForStockInReport')
  async getProductDropForStockInReport(@Body() req: UnitRequest): Promise<CommonResponse> {
    try {
      return await this.stockService.getProductDropForStockInReport(req);
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }
  @Post('/getSuperDummyStock')
  async getSuperDummyStock(@Body() req: UnitRequest): Promise<CommonResponse> {
    try {
      return await this.stockService.getSuperDummyStock(req);
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }
  @Post('/getAssignSuperDummyToRepack')
  async getAssignSuperDummyToRepack(@Body() req:AssignSuperDummyRepackingRequest):Promise<CommonResponse>{
    try {
      return await this.stockService.getAssignSuperDummyToRepack(req);
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }
  @Post('/getColdstorageCapacityAlert')
  async getColdstorageCapacityAlert():Promise<CommonResponse>{
    try {
      return await this.stockService.getColdstorageCapacityAlert();
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }
  @Post('/getStockInReverseReportdata')
  async getStockInReverseReportdata(@Body() req:StockInReverseReq):Promise<CommonResponse>{
    try {
      return await this.stockService.getStockInReverseReportdata(req);
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }

  @Post('/getSaleOrderDropForStockInReverse')
  async getSaleOrderDropForStockInReverse(@Body() req:StockInReverseReq):Promise<CommonResponse>{
    try {
      return await this.stockService.getSaleOrderDropForStockInReverse(req);
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }
  
  @Post('/getVariantDropForStockInReverse')
  async getVariantDropForStockInReverse(@Body() req:StockInReverseReq):Promise<CommonResponse>{
    try {
      return await this.stockService.getVariantDropForStockInReverse(req);
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }
  @Post('/getPlantDropForStockInReverse')
  async getPlantDropForStockInReverse(@Body() req:StockInReverseReq):Promise<CommonResponse>{
    try {
      return await this.stockService.getPlantDropForStockInReverse(req);
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }
  @Post('/getlocationsHistoryReportData')
  async getlocationsHistoryReportData():Promise<CommonResponse>{
    try {
      return await this.stockService.getlocationsHistoryReportData();
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }
  @Post('/getAllocatedStock')
  async getAllocatedStock(@Body() req:PlantIdRequest):Promise<CommonResponse> {
    try {
      return await this.stockService.getAllocatedStock(req);
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }
  @Post('/getReverseAllocatedStock')
 async getReverseAllocatedStock(@Body() req:AllocationRevereseRequest):Promise<CommonResponse> {
    try {
      return await this.stockService.getReverseAllocatedStock(req);
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }

  @Post('/getUpdateStockLocation')
  async getUpdateStockLocation(@Body() req:LocationUpdateRequest):Promise<CommonResponse> {
    try {
      return await this.stockService.getUpdateStockLocation(req);
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }

  @Post('/updateStockDomestic')
  async updateStockDomestic(@Body() req:StockUpdateByDomestic):Promise<CommonResponse> {
    try {
      return await this.stockService.updateStockDomestic(req);
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }

  @Post('/getLocationWiseInfoByStockId')
  async getLocationWiseInfoByStockId(@Body() req:StockIdsReq):Promise<CommonResponse> {
    try {
      return await this.stockService.getLocationWiseInfoByStockId(req);
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }

  @Post('/getSaleOrdersToAllocate')
  async getSaleOrdersToAllocate(@Body() req:StockOutTypeReq):Promise<CommonResponse> {
    try {
      return await this.stockService.getSaleOrdersToAllocate(req);
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }

  @Post('/updateCasesInStock')
  async updateCasesInStock():Promise<CommonResponse> {
    try {
      return await this.stockService.updateCasesInStock();
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }

  @Post('/getLotNumbersForStockOut')
  async getLotNumbersForStockOut(@Body() req: SoPlantRequest): Promise<CommonResponse> {
    try {
      //  console.log(req);
      return await this.stockService.getLotNumbersForStockOut(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getProductsInStock')
  async getProductsInStock(@Body() req: SoPlantRequest): Promise<CommonResponse> {
    try {
      //  console.log(req);
      return await this.stockService.getProductsInStock(req);
    } catch (error) {
      return this.applicationExceptionhandler.returnException(CommonResponse, error);
    }
  }
}
